'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _group = require('./group');

var _group2 = _interopRequireDefault(_group);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

var _pack = require('./pack');

var _pack2 = _interopRequireDefault(_pack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var axios = _util2.default.axios,
    cleanPacks = _util2.default.cleanPacks;
exports.default = {
  Pack: _pack2.default,
  Group: _group2.default,
  getCart: getCart,
  deletePacks: deletePacks,
  favoriteAjax: favoriteAjax,
  getVariant: getVariant,
  getStock: getStock
};


function getStock(spvId) {
  // return Promise.resolve({
  //   data: {
  //     spvId: 1,
  //     storeCount: 3,
  //     warehouseCount: 4
  //   }
  // }) 
  return axios({
    url: '/app/ipos/cart/spvStock?spvId=' + spvId
  });
}

function getGiftStock(spvId, cid) {}

function getCart() {
  // return Promise.resolve({ 
  //   data: require('../../data').default.cartData 
  // })
  return _promise2.default.resolve({
    data: {
      announcements: [],
      groups: [],
      invalidPacks: [],
      price: 0,
      savedPrice: 0
    }
  });
}

function deletePacks(packs) {
  return _promise2.default.resolve();
}

function favoriteAjax(packs) {
  return axios({
    url: '/app/cart/transfer',
    method: 'POST',
    json: {
      "to": "FAVORITE",
      "packIds": cleanPacks(packs)
    }
  });
}

function getVariant(productId) {
  return axios({
    url: '/app/product/' + productId + '/spvs',
    method: 'GET'
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/ipos/index.js
// module id = 1155
// module chunks = 0